import { create } from 'zustand';
import type { TwilioStore } from '@types';
import type { Call } from '@twilio/voice-sdk';

export const useTwilioStore = create<TwilioStore>((set, get) => ({
  status: 'uninitialized',
  hasActiveCall: false,
  activeCall: null,
  isMuted: false,
  callSid: null,
  conferenceName: null,

  setStatus: (status) => {
    set({ status });
  },
  setActiveCall: (active) => {
    set({ hasActiveCall: active });
  },
  setCall: (call: Call | null) => {
    set({ activeCall: call });
  },
  setIsMuted: (v) => {
    set({ isMuted: v });
  },
  setCallSid: (sid: string | null) => {
    set({ callSid: sid });
  },
  setConferenceName: (name: string | null) => {
    set({ conferenceName: name });
  },

  hangupCall: () => {
    const call = get().activeCall;
    if (call != null) {
      try {
        call.disconnect();
      } catch {}
    }
    set({
      activeCall: null,
      hasActiveCall: false,
      status: 'ready',
      isMuted: false,
      callSid: null,
      conferenceName: null,
    });
  },

  muteCall: () => {
    const { activeCall, isMuted } = get();
    if ((activeCall != null) && !isMuted) {
      try {
        activeCall.mute(true);
      } catch {}
      set({ isMuted: true });
    }
  },

  unmuteCall: () => {
    const { activeCall, isMuted } = get();
    if ((activeCall != null) && isMuted) {
      try {
        activeCall.mute(false);
      } catch {}
      set({ isMuted: false });
    }
  },
}));
